var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.svg)?_c('rmb',{staticClass:"rmb-svg",attrs:{"html":_vm.svg}}):_c('span',[_vm._v("¥")])}
var staticRenderFns = []

export { render, staticRenderFns }